import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from './lib/query';
import { router } from './app/router';
import { useAuthStore } from './store/auth';
import { ToastProvider } from './components/ui/toast';

export function App() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  // Attempt to restore a session from the refresh cookie on load.
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
